export default {
    methods: {
        noRequired(data) {
            return true;
        },
        maxLength(value,length){
            return String(value).length >= length;
        },
        minLength(value,length){
            return String(value).length <= length;
        },
        isRequired(data) {
            return !data
        },
        isArray(data) {
            return data.length != 0;
            // if (!Array.isArray(value) || value === undefined) {
            //     return false;
            //   }
            //   return true;
        },
        isEmail(email) {
            let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            if (emailPattern.test(email)) {
                return false;
            } else {
                return true;
            }
        },
        isPassword(password){
            let passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,15}$/;
            if(passwordPattern.test(password)){
                return false;
            } else {
                return true;
            }
        },
        isTel(phone) {
            let phonePattern = /^(0[2-8][0-5]?)-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/;
            if (phonePattern.test(phone)) {
                return false;
            } else {
                return true;
            }
        },
        isPhone(phone) {
            let phonePattern = /^(?:(010\d{4})|(070\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{5})$/;
            if (phonePattern.test(phone)) {
                return false;
            } else {
                return true;
            }
        },
        isUrl(url) {
            let urlPattern = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$.*/;
            if(urlPattern.test(url)){
                return false;
            } else {
                return true;
            }
        },
        isIp(ip) {
            let ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
            if(ipPattern.test(ip)){
                return false;
            } else {
                return true;
            }
        },
        isIpWithBandwidth(ip) {
            let ipWithBandwidthPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(~(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))?$/;
            return ipWithBandwidthPattern.test(ip);
        },
        isNumber(value) {
            let numberPattern = /^\d+(,\d+)*$/;
            if(numberPattern.test(value)){
                return false;
            } else {
                return true;
            }
        },
        isPhoneNumber(value) {
            let numberPattern = /^[0-9-]+$/;
            if(numberPattern.test(value)){
                return false;
            } else {
                return true;
            }
        },
        isInteger(value) {
            let seqPattern = /^-?([1-9]\d*|0)$/;
            if(seqPattern.test(value)){
                return false;
            } else {
                return true;
            }
        },
        isHp(hp) {
            let phonePattern = /^(01[016789]{1})[0-9]{3,4}[0-9]{4}$/;
            if (phonePattern.test(hp)) {
                return false;
            } else {
                return true;
            }
        },
        isSerial(value) {
            let serialPattern = /^[0-9|a-z|A-Z]+$/;
            if(serialPattern.test(value)){
                return false;
            } else {
                return true;
            }
        },
        isOnlyEngKorSpace(value) {
            let pattern = /^[a-zA-Z가-힣\s]+$/;
            return !pattern.test(value);
        }
    },
}
